export const ASSETS = {
  logo: "https://customer-assets-rejwkqb3.emergentagent.net/job_4ea71cde-a4d0-4acf-8f52-1fbf881bb771/artifacts/rbvpnw2f_Logo.png",
  heroVideo: "https://customer-assets-rejwkqb3.emergentagent.net/job_4ea71cde-a4d0-4acf-8f52-1fbf881bb771/artifacts/k7hd2xhq_allolabs_intro.mp4",
  boxMultiAngle: "https://customer-assets-rejwkqb3.emergentagent.net/job_4ea71cde-a4d0-4acf-8f52-1fbf881bb771/artifacts/g82xb6bl_Alibaba96d0d075451f724170a372bf18311703_original.png",
};

export const CONTACT = {
  email: "office@allolabspeps.uk",
  phone: "(+44) 7789086156",
};

export const DISCLAIMER =
  "WARNING & DISCLAIMER: All products listed on this website are strictly intended for in-vitro laboratory research, analytical testing, and institutional reference standards only. They are NOT medicines, food supplements, or cosmetics. These products are strictly NOT for human consumption, therapeutic, or diagnostic use. Bodily introduction of any kind is strictly prohibited.";
